import React from 'react'

const Header = () => {
    return (
        <div>
            <div className='py-4 max-w-[100vw] px-[5%] flex justify-between items-center text-white'>
                <p className='text-black hidden md:flex text-[42px] font1 tracking-[2px] font-bold'>PRINTOR</p>
                <div className='flex gap-4 items-center'>
                    <a href='https://t.me/printorSOL'>
                        <img className='h-[55px]' src={require('../assets/tg.png')} />
                    </a>
                    <a href='https://x.com/solprintoor'>
                        <img className='h-[55px]' src={require('../assets/tw.png')} />
                    </a>
                    <a href='https://dexscreener.com/solana/CYdZszyRqn5C9wiSrEvh9cZgeo3UeWb1mj1HiNBppump'>
                    <div className='bg-[#222] rounded-md py-4 px-6 font1 font-bold tracking-[2px]'>
                        DexScanner
                    </div>
                    </a>
                </div>
            </div>
            <div className='border-y-2 border-[#000] py-2 flex justify-center items-center text-black gap-4 font-bold bg-white'>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
                <p>$PRINTOR</p>
            </div>
        </div>
    )
}

export default Header